import Page from '@/found/components/table_page/table_page.vue';

export default {
  extends: Page,
  props: {
    propsObj: Array,
  },
  data() {
    return {
      formConfig: {},
      configs: {
        formConfig: {},
      },
      modalConfig: {},
      tableData: [],
    };
  },
  components: {},
  watch: {
    propsObj(v) {
      console.log(v);
      if (v.length > 0) {
        this.tableData = v;
        // this.selectRow = v.filter((item) => item.select === '1');
        // this.selection = this.selectRow.map((item) => item.permissionObjCode);
        // this.setSelectData();
      }
    },
  },
  created() {
    this.getConfigList('pro_list');
  },
  methods: {

  },
};
